import { render, staticRenderFns } from "./LoanInformationModal.vue?vue&type=template&id=0fa3c33a"
import script from "./LoanInformationModal.vue?vue&type=script&lang=js"
export * from "./LoanInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports